const utilSelector = {
  currentRoute: state => state.utilReducer.currentRoute,
  previousRoute: state => state.utilReducer.previousRoute,
  codLimit: state => state.utilReducer.codLimit,
  countryList: state => state.utilReducer.countryList,
  selectedSC: state => state.utilReducer.selectedSC,
  isOtpModalVisible: state => state.utilReducer.isOtpModalVisible,
}

export default utilSelector
